import { render, staticRenderFns } from "./RegistroFactura.vue?vue&type=template&id=8422c4d8&scoped=true&"
import script from "./RegistroFactura.vue?vue&type=script&lang=js&"
export * from "./RegistroFactura.vue?vue&type=script&lang=js&"
import style0 from "./RegistroFactura.vue?vue&type=style&index=0&id=8422c4d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8422c4d8",
  null
  
)

export default component.exports